import { useNavigate } from 'react-router-dom';
import SignUpSerivce from '../../service/signUp/SignUp';
import { AgreeState, feedbackMessages, REGEX, termList } from './data';
import { useTextField } from './SignUpForm';
import * as S from './SignUpForm.style';
import { useEffect, useState } from 'react';
import { useUser } from '../../context/UserContext';
import UserService from '../../service/User';

function SignUpFormSNS() {
  const navigate = useNavigate();

  const [loginType, setLoginType] = useState<string | null>(null);
  const [email, setEmail] = useState('');
  const [socialId, setSocialId] = useState<string | null>(null);

  const [isNameFixed, setIsNameFixed] = useState(false);
  const [isPhoneFixed, setIsPhoneFixed] = useState(false);
  const [agree, setAgree] = useState<AgreeState>({
    privacy: false,
    service: false,
    location: false,
    info: false,
    marketing: false,
    info_consent: false,
  });

  const [phonePhase, setPhonePhase] = useState<'idle' | 'sent' | 'verified'>(
    'idle',
  );
  const [secondsLeft, setSecondsLeft] = useState(0);

  const name = useTextField((v) => {
    if (!v) return null;
    return REGEX.name.test(v) ? null : 'invalid';
  });

  const phone = useTextField((v) => {
    if (!v) return null;
    return REGEX.phone.test(v) ? null : 'invalid';
  });

  const phoneCode = useTextField();
  const recommendCode = useTextField(undefined, false);

  const { setUser } = useUser();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('accessToken');
    const loginType = urlParams.get('socialLoginType');
    const email = urlParams.get('email');
    const userName = urlParams.get('name');
    const socialId = urlParams.get('socialId');
    const phoneValue = urlParams.get('tel');
    const infoAgree = urlParams.get('notification');
    const marketingAgree = urlParams.get('marketing');
    const info_consentAgree = urlParams.get('info_consent');

    const savedCode = localStorage.getItem('nonMemberRecommendCode');
    if (savedCode) {
      recommendCode.setValue(savedCode);
      recommendCode.setSuccess(true);
      recommendCode.setError(null);
    }

    if (!accessToken && (!loginType || !socialId)) {
      navigate('/login');
      return;
    }

    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      getUserInfo();
      const currentPath = localStorage.getItem('currentPath') ?? '/';
      localStorage.removeItem('socialLoginType');
      navigate(currentPath);
    } else {
      setLoginType(loginType);
      setSocialId(socialId);
      setEmail(!email || email === 'null' ? '' : String(email));
      name.setValue(!userName || userName === 'null' ? '' : String(userName));
      phone.setValue(
        !phoneValue || phoneValue === 'null' ? '' : String(phoneValue),
      );
      setIsNameFixed(!userName || userName === 'null' ? false : true);
      setIsPhoneFixed(!phoneValue || phoneValue === 'null' ? false : true);
      setAgree({
        ...agree,
        info: infoAgree === 'Y' ? true : false,
        marketing: marketingAgree === 'Y' ? true : false,
        info_consent: info_consentAgree === 'Y' ? true : false,
      });

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }, 0);
    }
  }, []);

  useEffect(() => {
    if (loginType === 'K') {
      setAgree({
        ...agree,
        privacy: true,
        service: true,
        location: true,
      });
    }
  }, [loginType]);

  useEffect(() => {
    if (isPhoneFixed) {
      phoneCode.setError(null);
      phoneCode.setSuccess(true);
      phone.setError(null);
      phone.setSuccess(true);
      setPhonePhase('verified');
      setSecondsLeft(-1);
    }
  }, [isPhoneFixed]);

  const getUserInfo = async () => {
    try {
      const res = await UserService.userInfo();
      localStorage.setItem('userName', res.data.name);
      localStorage.setItem('branchcode', res.data.branchcode);
      localStorage.setItem('department', res.data.department);
      localStorage.setItem('position', res.data.position);
      localStorage.setItem('name', res.data.name);
      localStorage.setItem('email', res.data.email);
      localStorage.setItem('tel', res.data.tel);
      localStorage.setItem('usertype', res.data.usertype);
      localStorage.setItem('state', res.data.state);
      localStorage.setItem('regdate', res.data.regdate);
      localStorage.setItem('notification', res.data.notification);
      localStorage.setItem('login_type', res.data.login_type);
      localStorage.setItem('plan_end', res.data.user.plan_end);
      localStorage.setItem(
        'recommend_code',
        res.data.user.recommend_code ?? '', // null이면 빈 문자열로 저장
      );
      setUser(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const isAllChecked = termList.every((t) => agree[t.state]);

  // 휴대폰 번호 인증번호 발송 버튼
  const handleSendCode = async () => {
    if (phone.error === 'invalid') {
      alert('휴대폰 번호를 정확하게 입력해 주세요.');
      return;
    }

    try {
      const result = await SignUpSerivce.SendSms({
        type: 'S',
        loginType, //k는 카카오, n은 네이버
        userid: socialId,
        tel: phone.value,
      });
      if (result.status === 'success') {
        phone.setError(null);
        setPhonePhase('sent');
        setSecondsLeft(180);
        phoneCode.setValue('');
        phoneCode.setError(null);
        phoneCode.setSuccess(false);
      }
    } catch (error: any) {
      // console.log(error);
      const msg =
        error?.response?.data?.message ?? '인증번호 발송에 실패했습니다.';
      if (msg === '이미 가입된 전화번호입니다.') {
        phone.setError('duplicate');
      } else {
        if (phonePhase === 'sent') {
          phoneCode.setError(msg);
        } else {
          phone.setError(msg);
        }
      }
    }
  };

  // mm:ss 표시
  const formatMMSS = (sec: number) => {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  // 인증번호 확인
  const handleVerifyCode = async () => {
    // 만료 체크
    if (secondsLeft <= 0) {
      phoneCode.setError('timeout');
      phoneCode.setSuccess(false);
      return;
    }

    if (!phoneCode.value) {
      phoneCode.setError('required');
      phoneCode.setSuccess(false);
      return;
    }

    try {
      await SignUpSerivce.CheckCode({
        type: 'S',
        loginType, //k는 카카오, n은 네이버
        userid: socialId,
        tel: phone.value,
        authCode: phoneCode.value,
      });

      phoneCode.setError(null);
      phoneCode.setSuccess(true);
      phone.setError(null);
      setPhonePhase('verified');
      setSecondsLeft(-1);
    } catch (error: any) {
      // alert(error.response.data.message);
      console.log(error);
      phoneCode.setError('mismatch');
      phoneCode.setSuccess(false);
    }
  };

  // 추천인코드 확인
  const handleVerifyRecommendCode = async () => {
    if (!recommendCode.value) return;
    if (localStorage.getItem('nonMemberRecommendCode')) return;

    try {
      const response = await SignUpSerivce.CheckRecommendCode(
        recommendCode.value,
      );
      const isValid = response?.data?.isValid;

      if (isValid) {
        recommendCode.setError(null);
        recommendCode.setSuccess(true);
      } else {
        recommendCode.setError('invalid');
        recommendCode.setSuccess(false);
      }
    } catch (error: any) {
      recommendCode.setError('invalid');
      recommendCode.setSuccess(false);
    }
  };

  // 3분 타이머
  useEffect(() => {
    if (phonePhase !== 'sent') return;
    if (secondsLeft <= 0) return;
    const t = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [phonePhase, secondsLeft]);

  const isNameOk = isNameFixed || (!!name.value && !name.error);
  const isPhoneOk = isPhoneFixed || phoneCode.success;

  // 추천인 코드(선택) OK 조건: 미입력 이거나, 입력 시 검증 성공
  const isRecommendOk = !recommendCode.value || recommendCode.success;

  //  필수 약관 동의
  const requiredTermsOk = termList
    .filter((t) => t.required)
    .every((t) => agree[t.state]);

  const avaliableSignup =
    isNameOk && isPhoneOk && isRecommendOk && requiredTermsOk;

  const handleSignup = (e: React.FormEvent) => {
    e.preventDefault();
    if (!avaliableSignup) return;
    // 제출 로직…
    sessionStorage.setItem('name', name.value);
    SignUpApi();
  };

  const SignUpApi = async () => {
    try {
      const result = await SignUpSerivce.signUp({
        usertype: 'I',
        userid: socialId,
        email: email,
        name: name.value,
        tel: phone.value,
        notification: agree.info ? 'Y' : 'N',
        marketing: agree.marketing ? 'Y' : 'N',
        info_consent: agree.info_consent ? 'Y' : 'N',
        loginType, //k는 카카오, n은 네이버
        code:
          typeof recommendCode.value === 'string'
            ? recommendCode.value
            : String(recommendCode.value),
      });
      if (result.status === 'success') {
        localStorage.removeItem('socialLoginType');
        navigate('/signUpComplete');
      }
    } catch (error: any) {
      const msg = error?.response?.data?.message;
      if (msg && msg === '이미 가입된 사용자입니다.') {
        alert('이미 다른 SNS 간편 로그인으로 사용 중인 번호입니다.');
      } else {
        alert(error.response.data.message);
      }
      console.log(error);
    }
  };

  const nameFeedback =
    name.error === 'required'
      ? feedbackMessages.name.required
      : name.error === 'invalid'
        ? feedbackMessages.name.invalid
        : feedbackMessages.name.default;
  const phoneFeedback =
    phone.error === 'required'
      ? feedbackMessages.phone.required
      : phone.error === 'invalid'
        ? feedbackMessages.phone.invalid
        : phone.error === 'duplicate'
          ? feedbackMessages.phone.duplicate
          : phone.error || feedbackMessages.phone.default;

  const phoneCodeFeedback =
    phoneCode.error === 'expired' || secondsLeft === 0
      ? feedbackMessages.phoneCode.timeout
      : phoneCode.error === 'required'
        ? feedbackMessages.phoneCode.required
        : phoneCode.error === 'mismatch'
          ? feedbackMessages.phoneCode.mismatch
          : phoneCode.error || feedbackMessages.phoneCode.default;

  return (
    <S.Form onSubmit={handleSignup} autoComplete="off">
      <S.Inner>
        <S.Section>
          <S.SectionTitle>이름</S.SectionTitle>
          <S.SectionContent>
            <S.InputGroup>
              <S.TextInput
                type="text"
                placeholder="실명을 입력해 주세요."
                value={name.value}
                onChange={(e) => name.onChange(e.target.value)}
                onBlur={name.onBlur}
                onFocus={() => name.setTouched(true)}
                $error={!!name.error}
                $success={isNameFixed}
                disabled={isNameFixed}
              />
            </S.InputGroup>
            {!!name.error && (
              <S.FeedbackArea>
                <S.IconWrapper>
                  <img src="/assets/images/icon/error-red.svg" alt="error" />
                </S.IconWrapper>
                <S.Feedback $error>{nameFeedback}</S.Feedback>
              </S.FeedbackArea>
            )}
          </S.SectionContent>
        </S.Section>

        <S.Section>
          <S.SectionTitle>휴대폰 번호</S.SectionTitle>
          <S.SectionContent>
            <S.InputGroup>
              <S.TextInput
                type="tel"
                placeholder="숫자만 입력해 주세요."
                value={phone.value}
                onChange={(e) => phone.onChange(e.target.value)}
                onBlur={phone.onBlur}
                onFocus={() => phone.setTouched(true)}
                $error={!!phone.error}
                $success={phoneCode.success}
                disabled={phoneCode.success}
              />
              {phonePhase === 'verified' ? null : (
                <S.InputConfirmButton
                  type="button"
                  $disabled={!phone.value && phonePhase !== 'sent'}
                  $isRecent={phonePhase === 'sent'}
                  onClick={handleSendCode}
                >
                  {phonePhase === 'sent' ? '재발송' : '인증번호 발송'}
                </S.InputConfirmButton>
              )}
            </S.InputGroup>
            {phonePhase === 'idle' && !!phone.error && (
              <S.FeedbackArea>
                <S.IconWrapper>
                  <img src="/assets/images/icon/error-red.svg" alt="error" />
                </S.IconWrapper>
                <S.Feedback $error>{phoneFeedback}</S.Feedback>
              </S.FeedbackArea>
            )}
          </S.SectionContent>
          {phonePhase !== 'idle' && !isPhoneFixed && (
            <S.SectionContent>
              <S.InputGroup>
                <S.TextInput
                  type="tel"
                  placeholder="인증번호 6자리를 입력해 주세요."
                  value={phoneCode.value}
                  onChange={(e) => phoneCode.onChange(e.target.value)}
                  onBlur={phoneCode.onBlur}
                  onFocus={() => phoneCode.setTouched(true)}
                  $error={!!phoneCode.error}
                  $success={phoneCode.success}
                  disabled={phoneCode.success}
                />
                <S.InputConfirmButton
                  type="button"
                  $disabled={phonePhase === 'verified' || secondsLeft === 0}
                  onClick={handleVerifyCode}
                >
                  {phonePhase === 'verified' ? '확인완료' : '인증번호 확인'}
                </S.InputConfirmButton>
              </S.InputGroup>
              {phonePhase !== 'verified' && (
                <S.FeedbackArea>
                  <S.TimeLeftLabel>입력대기시간 :</S.TimeLeftLabel>
                  <S.Feedback $error>
                    {formatMMSS(Math.max(0, secondsLeft))}
                  </S.Feedback>
                </S.FeedbackArea>
              )}
              {(!!phoneCode.error || secondsLeft === 0) && (
                <S.FeedbackArea>
                  <S.IconWrapper>
                    <img src="/assets/images/icon/error-red.svg" alt="error" />
                  </S.IconWrapper>
                  <S.Feedback $error>{phoneCodeFeedback}</S.Feedback>
                </S.FeedbackArea>
              )}
            </S.SectionContent>
          )}
        </S.Section>

        <S.Section>
          <S.SectionTitleOptional>
            <S.SectionTitle>추천인 코드</S.SectionTitle>
            (선택)
          </S.SectionTitleOptional>
          <S.SectionContent>
            <S.InputGroup>
              <S.TextInput
                type="text"
                placeholder="추천인 코드를 입력해 주세요."
                value={recommendCode.value}
                onChange={(e) => recommendCode.onChange(e.target.value)}
                onBlur={recommendCode.onBlur}
                onFocus={() => recommendCode.setTouched(true)}
                $error={!!recommendCode.error}
                $success={recommendCode.success}
                disabled={recommendCode.success}
                readOnly={!!localStorage.getItem('nonMemberRecommendCode')} // readOnly 적용
              />
              <S.InputConfirmButton
                $disabled={recommendCode.success || !recommendCode.value}
                onClick={handleVerifyRecommendCode}
              >
                {recommendCode.success ? '확인완료' : '확인'}
              </S.InputConfirmButton>
            </S.InputGroup>
            {!!recommendCode.error && (
              <S.FeedbackArea>
                <S.IconWrapper>
                  <img src="/assets/images/icon/error-red.svg" alt="error" />
                </S.IconWrapper>
                <S.Feedback $error>존재하지 않는 추천인 코드입니다.</S.Feedback>
              </S.FeedbackArea>
            )}
          </S.SectionContent>
        </S.Section>

        {loginType !== 'K' && (
          <S.Section>
            <S.SectionTitle>약관동의</S.SectionTitle>
            <S.TermsBox>
              <S.TermsRow
                onClick={() => {
                  if (isAllChecked) {
                    setAgree({
                      privacy: false,
                      service: false,
                      location: false,
                      info: false,
                      marketing: false,
                      info_consent: false,
                    });
                    return;
                  }
                  setAgree({
                    privacy: true,
                    service: true,
                    location: true,
                    info: true,
                    marketing: true,
                    info_consent: true,
                  });
                }}
              >
                <S.AllAgreeCheckbox $checked={isAllChecked}>
                  {isAllChecked && (
                    <img
                      src="/assets/images/check/check-blue-on.svg"
                      alt="checked"
                    />
                  )}
                </S.AllAgreeCheckbox>
                <S.AllAgree>전체 동의</S.AllAgree>
                <S.TermsValue>(선택사항 포함)</S.TermsValue>
              </S.TermsRow>
              <S.Divider />
              <S.TermsList>
                {termList.map((item) => {
                  const key = item.state;
                  return (
                    <S.TermsRow
                      key={item.state}
                      onClick={() => {
                        setAgree({
                          ...agree,
                          [key]: !agree[key],
                        });
                      }}
                    >
                      {agree[key] ? (
                        <S.Checkbox>
                          <img
                            src="/assets/images/check/check-blue-on.svg"
                            alt="checked"
                          />
                        </S.Checkbox>
                      ) : (
                        <S.Checkbox />
                      )}
                      <S.TermsContent>
                        <S.TermsValue>
                          {item.required ? <span>[필수]</span> : '[선택]'}{' '}
                          {item.name}
                        </S.TermsValue>
                        <S.SeeMoreButton
                          src="/assets/images/arrow/arrow-right-gray-small.svg"
                          alt=""
                          onClick={(
                            e: React.MouseEvent<HTMLElement, MouseEvent>,
                          ) => {
                            e.stopPropagation();
                            window.open(item.url, '_blank');
                          }}
                        />
                      </S.TermsContent>
                    </S.TermsRow>
                  );
                })}
              </S.TermsList>
            </S.TermsBox>
          </S.Section>
        )}
      </S.Inner>
      <S.SignupButton $disabled={!avaliableSignup} type="submit">
        가입하기
      </S.SignupButton>
    </S.Form>
  );
}

export default SignUpFormSNS;
